import { Field } from '@/types/core/Field';
import { Action, createAction } from '@/types/core/Link';

/**
 * Base fields for all actions
 */
export const actionBaseFields: Field[] = [
  {
    key: 'name',
    type: 'string',
    label: 'Name',
    default: '',
    panel: 'transform'
  },
  {
    key: 'enabled',
    type: 'boolean',
    label: 'Enabled',
    default: true,
    panel: 'transform'
  },
  {
    key: 'targetItemId',
    type: 'select',
    label: 'Target Item',
    default: '',
    panel: 'transform',
    options: []  // Will be populated dynamically
  },
  {
    key: 'targetProperty',
    type: 'select',
    label: 'Target Property',
    default: '',
    panel: 'transform',
    options: []  // Will be populated dynamically
  },
  {
    key: 'type',
    type: 'button-group',
    label: 'Action Type',
    default: 'minmax',
    panel: 'transform',
    options: [
      { label: 'Min/Max', value: 'minmax' },
      { label: 'Toggle', value: 'toggle' }
    ]
  },
  {
    key: 'easing',
    type: 'button-group',
    label: 'Easing',
    default: 'linear',
    panel: 'transform',
    options: [
      { label: 'Linear', value: 'linear' },
      { label: 'Ease In', value: 'easeIn' },
      { label: 'Ease Out', value: 'easeOut' },
      { label: 'Ease In/Out', value: 'easeInOut' },
    ]
  },
  {
    key: 'curve',
    type: 'button-group',
    label: 'Curve',
    default: 'linear',
    panel: 'transform',
    options: [
      { label: 'Linear', value: 'linear' },
      { label: 'Smooth', value: 'smooth' },
    ]
  },
  {
    key: 'restValue',
    type: 'number',
    label: 'Rest Value',
    default: 0,
    panel: 'transform'
  }
];

/**
 * Fields specific to MinMax actions
 */
export const minMaxFields: Field[] = [
  {
    key: 'range.min',
    type: 'number',
    label: 'Min Value',
    default: 0,
    panel: 'transform'
  },
  {
    key: 'range.max',
    type: 'number',
    label: 'Max Value',
    default: 1,
    panel: 'transform'
  }
];

/**
 * Fields specific to Toggle actions
 */
export const toggleFields: Field[] = [
  {
    key: 'defaultState',
    type: 'boolean',
    label: 'Default State',
    default: false,
    panel: 'transform'
  }
];

/**
 * Creates a new MinMax action with default values
 */
export const createMinMaxAction = (name: string): Action => {
  return createAction('minmax', name);
};

/**
 * Creates a new Toggle action with default values
 */
export const createToggleAction = (name: string): Action => {
  return createAction('toggle', name);
}; 